import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Component({
  selector: 'app-zonasegura',
  templateUrl: './zonasegura.component.html',
  styleUrls: ['./zonasegura.component.css']
})
export class ZonaseguraComponent implements OnInit {
  usuario: AccountInfo | null = null;
  nombreUsuario = '';

  constructor(private msalService: MsalService) {}

  ngOnInit(): void {
    const account = this.msalService.instance.getActiveAccount();
    if (account) {
      this.usuario = account;
      this.nombreUsuario = account.name ?? account.username ?? '';
    }
  }

  cerrarSesion(): void {
    this.msalService.logoutRedirect();
  }
}
